module.exports = __webpack_public_path__ + "static/media/404Image.6933fb59.svg";